'use client'

import { gql } from '../../../__generated__/graphql/catalog/gql'
import { NavListGroupSectionFragmentFragment } from '../../../__generated__/graphql/catalog/graphql'

import { PrimaryNavContentfulSections } from './PrimaryNavContentfulSections.client'
import { PrimaryNavItemListSection } from './PrimaryNavItemListSection.client'

type PrimaryNavItemListGroupSectionProps = NavListGroupSectionFragmentFragment

export const navListGroupSectionQueryFragment = gql(`
  fragment NavListGroupSectionFragment on NavListGroupSection {
    __typename
    id
    navSections {
      ...NavListSectionFragment
    }
  }
`)

export const PrimaryNavItemListGroupSection = ({
  navSections,
}: PrimaryNavItemListGroupSectionProps) => {
  return (
    <PrimaryNavContentfulSections>
      {navSections.map((navSection, index) => {
        return <PrimaryNavItemListSection key={index} {...navSection} />
      })}
    </PrimaryNavContentfulSections>
  )
}
